export default __webpack_public_path__ + "static/media/instagram_grey.f1b15f24.svg";